import { render } from "./uk13.vue?vue&type=template&id=4d95b30c"
import script from "./uk13.vue?vue&type=script&lang=js"
export * from "./uk13.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__